import { render, staticRenderFns } from "./certificados_precios_config.vue?vue&type=template&id=912b08e6&"
import script from "./certificados_precios_config.vue?vue&type=script&lang=js&"
export * from "./certificados_precios_config.vue?vue&type=script&lang=js&"
import style0 from "./certificados_precios_config.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports